import React, { Fragment } from "react";
import styles from "../../../styles/wide-banner.module.scss";
import { Hidden } from "@mui/material";
import Image from "@/components/UI/Image";

interface WideBannerProps {
  name?:string
  desktop_image?: string;
  tablet_image?: string;
  mobile_image?: string;
  dimensions?: {
    desktop?: {
      width?: number;
      height?: number;
    };
    tablet?: {
      width?: number;
      height?: number;
    };
    mobile?: {
      width?: number;
      height?: number;
    };
  };
}

const WideBanner: React.FC<WideBannerProps> = ({
  desktop_image,
  tablet_image,
  mobile_image,
  dimensions,
  name
}) => {
  return (
    <>
      {/* Mobile */}
      <Hidden only={["md", "lg", "xl"]}>
        {mobile_image && (
          <div className={styles.banner_container}>
            <Image
              src={mobile_image}
              width={dimensions?.mobile?.width || 960}
              height={dimensions?.mobile?.height || 250}
              objectFit="fill"
              alt={name}
            />
          </div>
        )}
      </Hidden>

      {/* Tablet */}
      <Hidden only={["xs", "sm", "lg", "xl"]}>
        {tablet_image && (
          <div className={styles.banner_container}>
            <Image
              className={styles.tabs_views}
              src={tablet_image}
              width={dimensions?.tablet?.width || 1280}
              height={dimensions?.tablet?.height || 400}
              objectFit="fill"
              alt={name}
            />
          </div>
        )}
      </Hidden>

      {/* Desktop */}
      <Hidden only={["xs", "sm", "md"]}>
        {desktop_image && (
          <div className={styles.banner_container}>
            <Image
              src={desktop_image}
              width={dimensions?.desktop?.width || 1920}
              height={dimensions?.desktop?.height || 380}
              objectFit="fill"
              alt={name}
            />
          </div>
        )}
      </Hidden>
    </>
  );
};

export default WideBanner;
